export function findLinkedVariant(target, source, selectedVariant, linkedValues = {}) {
  const sharedOptions = target.optionNames.flatMap((name, targetIndex) => {
    const configuredName = Object.keys(linkedValues).find((key) => key.toLowerCase() === name.toLowerCase());
    if (configuredName) return [{ targetIndex, value: linkedValues[configuredName] }];
    const sourceIndex = source.optionNames.findIndex(
      (sourceName) => sourceName.toLowerCase() === name.toLowerCase(),
    );
    return sourceIndex < 0 ? [] : [{ targetIndex, value: selectedVariant.options[sourceIndex] }];
  });
  if (!sharedOptions.length) return target.defaultVariantId;
  return target.variants.find((variant) =>
    sharedOptions.every(({ targetIndex, value }) => variant.options[targetIndex] === value),
  )?.id ?? target.defaultVariantId;
}

if (typeof customElements !== 'undefined' && !customElements.get('product-linked-options')) {
  customElements.define('product-linked-options', class extends HTMLElement {
    connectedCallback() {
      const config = this.querySelector('[data-linked-options-config]');
      if (!config) return;
      try {
        this.config = JSON.parse(config.textContent);
      } catch {
        return;
      }
      this.source = this.config.products.find((product) => String(product.id) === this.dataset.productId);
      if (!this.source) return;
      this.links = [...this.querySelectorAll('a[data-linked-product-id]')];
      this.movedLinks = [];
      const form = this.closest('form');
      this.querySelectorAll('[data-native-option-index]').forEach((group) => {
        const target = form?.querySelector(`.variant-input-wrap[data-index="option${group.dataset.nativeOptionIndex}"] .grid-product__variants`);
        if (!target) return;
        const original = group.querySelector('.vego-product-options-style-links');
        [...original.children].forEach((link) => {
          target.append(link);
          this.movedLinks.push({ link, original, group });
        });
        group.hidden = true;
      });
      this.onVariantChange = (event) => {
        const variant = event.detail?.variant;
        if (variant) this.updateLinks(variant.id);
      };
      document.addEventListener('variant:change', this.onVariantChange);
      this.updateLinks(this.config.currentVariantId);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariantChange);
      this.movedLinks?.forEach(({ link, original, group }) => {
        original.append(link);
        group.hidden = false;
      });
    }

    updateLinks(variantId) {
      const selected = this.source.variants.find((variant) => String(variant.id) === String(variantId));
      if (!selected) return;
      this.links.forEach((link) => {
        const target = this.config.products.find((product) => String(product.id) === link.dataset.linkedProductId);
        if (!target) return;
        const url = new URL(link.href, window.location.origin);
        const linkedValues = JSON.parse(link.dataset.linkedOptionValues || '{}');
        url.searchParams.set('variant', String(findLinkedVariant(target, this.source, selected, linkedValues)));
        link.href = url.href;
      });
    }
  });
}
